/* CacaoMood Homepage — GSAP Animations */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  /* Hero sequence */
  var heroTag  = document.querySelector('.cm-hero__tag');
  var heroH1   = document.querySelector('.cm-hero__h1');
  var heroDesc = document.querySelector('.cm-hero__desc');
  var heroBtns = document.querySelector('.cm-hero__btns');
  var heroTins = document.querySelectorAll('.cm-hero__tin');
  if (heroTag) {
    var tl = gsap.timeline({ delay: 0.3 });
    tl.to(heroTag,  { opacity:1, duration:0.6, ease:'power2.out' })
      .to(heroH1,   { opacity:1, y:0, duration:0.8, ease:'power3.out' }, '-=0.2')
      .to(heroDesc, { opacity:1, y:0, duration:0.7, ease:'power2.out' }, '-=0.4')
      .to(heroBtns, { opacity:1, duration:0.6 }, '-=0.3')
      .to(heroTins, { opacity:1, y:0, duration:0.7, stagger:0.15, ease:'back.out(1.4)' }, '-=0.4');
  }

  /* Generic scroll reveals */
  document.querySelectorAll('.cm-reveal').forEach(function (el) {
    gsap.to(el, {
      scrollTrigger: { trigger: el, start: 'top 88%' },
      opacity: 1, y: 0, duration: 0.8, ease: 'power2.out'
    });
  });
  document.querySelectorAll('.cm-reveal-left').forEach(function (el) {
    gsap.to(el, { scrollTrigger: { trigger: el, start: 'top 80%' }, opacity:1, x:0, duration:0.9, ease:'power2.out' });
  });
  document.querySelectorAll('.cm-reveal-right').forEach(function (el) {
    gsap.to(el, { scrollTrigger: { trigger: el, start: 'top 80%' }, opacity:1, x:0, duration:0.9, ease:'power2.out' });
  });

  /* Product cards (homepage + about page) */
  var productCards = document.querySelectorAll('.cm-product-card, .cm-about-card');
  if (productCards.length) {
    gsap.to(productCards, { scrollTrigger: { trigger: productCards[0], start: 'top 85%' }, opacity:1, y:0, duration:0.7, stagger:0.15, ease:'power2.out' });
  }

  /* How-to cards */
  var howtoCards = document.querySelectorAll('.cm-howto__card');
  if (howtoCards.length) {
    gsap.to(howtoCards, { scrollTrigger: { trigger: howtoCards[0], start: 'top 85%' }, opacity:1, y:0, duration:0.7, stagger:0.18, ease:'power2.out' });
  }

  /* Review cards */
  var reviewCards = document.querySelectorAll('.cm-review-card');
  if (reviewCards.length) {
    gsap.to(reviewCards, { scrollTrigger: { trigger: reviewCards[0], start: 'top 85%' }, opacity:1, y:0, duration:0.6, stagger:0.1, ease:'power2.out' });
  }

  /* Instagram posts */
  var igPosts = document.querySelectorAll('.cm-instagram__post');
  if (igPosts.length) {
    gsap.to(igPosts, { scrollTrigger: { trigger: igPosts[0], start: 'top 85%' }, opacity:1, scale:1, duration:0.6, stagger:0.12, ease:'back.out(1.2)' });
  }

  /* Compare dots */
  function buildDots() {
    document.querySelectorAll('.cm-dots[data-filled]').forEach(function (c) {
      var filled = +c.dataset.filled;
      var total  = +c.dataset.total;
      c.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var d = document.createElement('div');
        d.className = 'cm-dot' + (i >= filled ? ' cm-dot--empty' : '');
        c.appendChild(d);
      }
    });
  }
  buildDots();
  document.querySelectorAll('.cm-compare').forEach(function (section) {
    ScrollTrigger.create({
      trigger: section,
      start: 'top 85%',
      onEnter: function () {
        section.querySelectorAll('.cm-dot:not(.cm-dot--empty)').forEach(function (d, i) {
          gsap.to(d, { opacity:1, scale:1, duration:0.4, delay:0.06*i, ease:'back.out(2)' });
        });
      }
    });
  });

  /* Nav shadow on scroll */
  window.addEventListener('scroll', function () {
    var nav = document.querySelector('.shopify-section-header-sticky') || document.querySelector('header') || document.getElementById('shopify-section-header');
    if (nav) nav.classList.toggle('cm-nav-scrolled', window.scrollY > 60);
  }, { passive: true });
});
